import Cookie from 'vue-cookie';
import VueRouter from 'vue-router';

function lazyLoad(component) {
    return () => import('' + component + '');
}

const DEFAULT_TITLE = 'Easy User Test';
let routes = [
    {
        path: '/',
        redirect: '/tests'
    },
    {
        path: '/login',
        name: 'login',
        component: lazyLoad('./components/auth/login'),
        meta: {unAuth: true, fluidLayout: true, noNav: true, title: 'Login'}
    },
    {
        path: '/register',
        name: 'register',
        component: lazyLoad('./components/auth/register'),
        meta: {unAuth: true, fluidLayout: true, noNav: true, title: 'Registration'}
    },
    {
        path: '/reset_password',
        name: 'reset_password',
        component: lazyLoad('./components/auth/reset-password'),
        meta: {unAuth: true, fluidLayout: true, noNav: true}
    },
    {
        path: '/reset-password/:token/:email',
        name: 'reset-password-form',
        component: lazyLoad('./components/auth/form-reset-password'),
        meta: {unAuth: true, fluidLayout: true, title: 'Password Reset', noNav: true}
    },
    {
        path: '/auth/:provider/callback',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
    {
        path: '/account',
        name: 'account',
        component: lazyLoad('./components/account'),
        meta: {auth: true, title: 'Profile'}
    },
    {
        path: '/tests',
        name: 'tests_active',
        component: lazyLoad('./components/tests/tests-active'),
        meta: {auth: true, title: 'Active Tests List'}
    },
    {
        path: '/tests/completed',
        name: 'tests_completed',
        component: lazyLoad('./components/tests/tests-completed'),
        meta: {auth: true, title: 'Completed Tests List'}
    },
    {
        path: '/tests/drafts',
        name: 'tests_drafts',
        component: lazyLoad('./components/tests/tests-drafts'),
        meta: {auth: true, title: 'Draft Tests List'}
    },
    {
        path: '/tests/create',
        name: 'tests_create',
        component: lazyLoad('./components/tests/tests-wizard'),
        meta: {auth: true, title: 'Test Wizard: Create'}
    },
    {
        path: '/tests/:testId/results',
        name: 'test_results',
        component: lazyLoad('./components/tests/test-results'),
        props: true,
        meta: {auth: true, title: 'Test Results'}
    },
    {
        path: '/tests/:testId/edit',
        name: 'test_edit',
        component: lazyLoad('./components/tests/tests-wizard'),
        props: true,
        meta: {auth: true, title: 'Test Wizard: Draft'}
    },
    {
        path: '/test/:hash',
        name: 'test-flow-wrapper',
        component: lazyLoad('./components/test-flow/wrapper'),
        meta: {noNav: true, title: 'Test Flow'}
    },
    {
        path: '/*/test/:hash',
        name: 'test-flow-wrapper',
        component: lazyLoad('./components/test-flow/wrapper'),
        meta: {noNav: true, title: 'Test Flow'}
    },
    {
        path: '/test-demo/:hash',
        name: 'test-demo-flow-wrapper',
        component: lazyLoad('./components/test-flow/wrapper'),
        props: {isDemo: true},
        meta: {noNav: true, auth: true, title: 'Demo Test Flow'}
    },
    {
        path: '/*',
        name: 'static',
        component: lazyLoad('./components/static-pages'),
        meta: {fluidLayout: true, noNav: true}
    },

    // Page not found
    {
        path: '/404',
        alias: '*',
        name: 'PageNotFound',
        component: lazyLoad('./components/not-found'),
        meta: {title: '404 - Not Found'}
    }
];

const router = new VueRouter({
    hashbang: false,
    mode: 'history',
    routes,
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            }
        } else {
            return {x: 0, y: 0}
        }
    },
});

router.beforeEach((to, from, next) => {
    let langRegexp = new RegExp('^\/(en|de|fr|it)\/');
    if (langRegexp.test(to.fullPath)) {
        return next({
            path: to.fullPath.replace(langRegexp, '/')
        });
    }
    if (to.matched.some(record => record.meta.auth)) {
        if (!window._store.getters['auth/isLoggedIn']) {
            window._store.commit('auth/rememberBackRoute', {name: to.name});
            return next({
                name: 'login'
            });
        }
    }

    if (to.matched.some(record => record.meta.unAuth)) {
        if (window._store.getters['auth/isLoggedIn']) {
            return next({
                name: 'tests_active',
            });
        }
    }

    next();
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title ? to.meta.title + ' | ' + DEFAULT_TITLE : DEFAULT_TITLE;
    });
});

export default router;
